// A helper function to fetch Scenario Data

export async function fetchProgram(brand, authToken, trainingprogram_id) {
    try {
        const response = await fetch(`${brand.api_base_url}/trainingprograms?trainingprogram_id=${trainingprogram_id}`, {
            headers: { 'Authorization': `Token ${authToken}` },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        console.error('Error fetching scenario:', err.message);
        return null;
    }
}
